/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/LineBreak/theme';

export const LineBreakTheme = theme;
